<template>
      <footer v-if="loaded">
        <div class="site-footer">
          <div class="site-footer__inner">
            <div class="site-footer__image">
              <img :src='footerData.image.url' :alt='footerData.image.alt'/>
            </div>
            <div class="site-footer__block">
              <cmscontent :content='footerData.block_1'/>
            </div>
            <div class='site-footer__block-small'></div>
            <div class="site-footer__block">
              <cmscontent :content='footerData.block_2'/>
            </div>
            <div class="site-footer__block-small">
              <cmscontent :content='footerData.block_3'/>
            </div>
          </div>
        </div>
      </footer>
</template>

<script>
    import Vue from 'vue'
    export default {

        mounted: function () {
          this.loaded = false;
          this.getFooter();
        },
        data() {
            return {
              footerData: null,
              loaded: false,
            };

        },
        methods: {
          getFooter() {
            this.$store.dispatch('getFooter').then(footerData => {
              this.footerData = footerData
              this.loaded = true;
            });
          }
        },
    };


</script>

<style lang="scss">
    @import "./style";
</style>